// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a579ef1d","239":"da78224e","453":"57902a17","634":"d0dfb477"}[chunkId] + ".chunk.js";
};